import i18n from 'i18next';
import { debounce } from 'lodash-es';
import { initReactI18next } from 'react-i18next';
import translations from '~/translations/en';
import platformConfig from '~/configurations/platform';

const { lang: defaultLang } = platformConfig;

// Adding a 2s timeout so that it can group errors
// at first run and after the 1st api call (approx).
const DEBOUNCE_TIMEOUT = 2000;
const missingKeyErrors = new Set();

const flushMissingKeyError = debounce(() => {
  const missingKeyErrorsStr = Array.from(missingKeyErrors).filter((key: string) => !i18n.exists(key)).join('\n');
  if (!missingKeyErrorsStr) {
    return;
  }

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error(`Missing translation key:\n${missingKeyErrorsStr}`);
  }

  missingKeyErrors.clear();
}, DEBOUNCE_TIMEOUT);

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n
  .use(initReactI18next)
  .init({
    debug: false,
    defaultNS: 'common',
    fallbackLng: defaultLang,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    lng: defaultLang,
    missingKeyHandler(_, namespace, key) {
      missingKeyErrors.add(`${namespace}:${key}`);
      flushMissingKeyError();
    },
    resources: {
      [defaultLang]: translations,
    },
    saveMissing: true,
  });

export default i18n;
